export const allowedMimeTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'] as const

export const isValidMimeType = (mimeType: string): boolean =>
  allowedMimeTypes.includes(mimeType as (typeof allowedMimeTypes)[number])

export const mimeTypeMap = {
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  gif: 'image/gif',
} as const
